import { render, staticRenderFns } from "./InvoiceEditView.vue?vue&type=template&id=08bfd1d2&"
import script from "./InvoiceEditView.vue?vue&type=script&lang=js&"
export * from "./InvoiceEditView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceEditView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports